var vvSearch = (function () {
	var wrap, input, output, templateEmpty, templateWrap, templateItem, mainAside, mainPage;
	var timeout, queryUrl, currentUrl, hostUrl, pageId;

	function init() {
		wrap = document.querySelector('.vvSearch');
		input = document.querySelector('#vvSearch');
		mainAside = document.querySelector('aside');
		mainPage = document.querySelector('#main');
		if (!input || !wrap) {
			return;
		}
		initInput();
	}

	function initInput() {
		queryUrl = wrap.dataset.url;
		pageId = parseInt(wrap.dataset.p);
		currentUrl = stripHashFromUrl(window.location.href);
		hostUrl = getHostUrl(currentUrl);
		input.addEventListener('keyup', onKeyUp);
		output = wrap.querySelector('.vvSearch__output');
		templateEmpty = wrap.querySelector('template#vvSearchEmpty');
		templateItem = wrap.querySelector('template#vvSearchItem');
		templateWrap = wrap.querySelector('template#vvSearchWrap');
		window.addEventListener('click', function (e) {
			var t = e.target;
			if (t instanceof Element) {
				if (t.id === 'vvSearch' || t.classList.contains('vvSearch__input')) {
					return true;
				}
			}
			return true;
		});
		input.addEventListener('focus', function () {
			if (!output.classList.contains('empty')) {
				output.classList.add('active');
			}
		});
	}

	function onKeyUp() {
		clearTimeout(timeout);
		timeout = setTimeout(doSearch, 500);
	}

	function doSearch() {
		var q = input.value;
		if (q.length < 3) {
			output.classList.add('empty');
			removeHighlighting();
			return;
		}
		fetch(queryUrl + '?q=' + q + '&p=' + pageId).then(function (response) {
			return response.json();
		}).then(doResults);
	}

	function doResults(data) {
		output.classList.add('active');
		output.classList.remove('empty');
		removeHighlighting();

		var numFound = parseInt(data.numFound),
			query = data.q;
		if (numFound < 1) {
			output.innerHTML = render(templateEmpty, {
				q: query
			});
		}
		else {
			output.innerHTML = render(templateWrap, {
				numFound: numFound,
				items: renderItems(templateItem, prepareDocs(data))
			});
			highlightLocal(data);
			prepareItemClicks();
		}
	}

	function prepareItemClicks() {
		output.querySelectorAll('a').forEach(function (item) {
			var itemUrl = stripHashFromUrl(item.href);
			if (isSamePage(itemUrl)) {
				item.addEventListener('click', function () {
					document.body.classList.remove('search-open');
				});
			}
		});
	}

	function isSamePage(url) {
		return url === currentUrl;
	}

	function stripHashFromUrl(url) {
		return url.replace(/#.*/, '');
	}

	function getHostUrl(url) {
		return url.replace(/^(https?:\/\/[^\/]+)\/.*/, '$1');
	}

	function getHashFromUrl(url) {
		return url.replace(/.*#/, '');
	}

	function sortByStrLength(arr) {
		arr.sort(function (a, b) {
			var la = a.length, lb = b.length;
			return la > lb ? 1 : -1;
		});
	}

	function arrayUnique(arr) {
		return arr.filter(function (value, index, self) {
			return self.indexOf(value) === index;
		});
	}

	function findDocIdBase(highlighting) {
		var searchString = '/sitemap/index/index/';
		var slen = searchString.length;
		var keys = Object.keys(highlighting);
		for (var i = 0, c = keys.length; i < c; i++) {
			var key = keys[i];
			var index = key.indexOf(searchString);
			if (index > -1) {
				return key.substr(0, index + slen);
			}
		}
		return '';
	}

	function highlightLocal(data) {
		var foundStrings = [];
		var docIdBase = findDocIdBase(data.highlighting) + pageId;

		var l = docIdBase.length;
		Object.keys(data.highlighting).forEach(function (k) {
			if (data.highlighting[k].content && k.substr(0, l) === docIdBase) {
				data.highlighting[k].content.forEach(function (item) {
					var parts = item.replace(/.*<solrFound>(.*)<\/solrFound>.[\s\S]*/g, '$1')
						.split("\n")
						.filter(function (value) {
							return value.trim().length >= 3;
						});
					foundStrings = foundStrings.concat(parts);
				});
			}
		});
		foundStrings = arrayUnique(foundStrings);
		sortByStrLength(foundStrings);
		highlightTextNodes(foundStrings);
	}

	function highlightTextNodes(stringsToFind) {
		var textNodes = findTextNodes(mainPage);
		textNodes.forEach(function (node) {
			var nodeParent = node.parentNode;
			if (!nodeParent || !nodeParent.innerHTML) {
				return;
			}

			var span = document.createElement('span');
			span.innerHTML = node.textContent;
			var found = false;

			stringsToFind.forEach(function (str) {
				if (node.textContent.indexOf(str) > -1) {
					var reg = new RegExp("\\b" + str + "\\b", 'g');
					span.innerHTML = span.innerHTML.replace(reg, '<span class="h">' + str + '</span>');
					found = true;
				}
			});

			if (found) {
				nodeParent.insertBefore(span, node);
				nodeParent.removeChild(node);
			}
		});
	}

	function removeHighlighting() {
		var spans = mainPage.getElementsByClassName('h');
		while (spans.length > 0) {
			var span = spans[0];
			var p = span.parentNode;
			if (!p) {
				continue;
			}
			var x = span.outerHTML;
			p.innerHTML = p.innerHTML.replace(x, span.innerHTML);
		}
	}

	function findTextNodes(el) {
		var n, a = [], walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
		// noinspection JSAssignmentUsedAsCondition
		while (n = walk.nextNode()) {
			a.push(n);
		}
		return a;
	}

	function prepareDocs(data) {
		var ret = [];
		data.docs.forEach(function (doc) {
			var id = doc.id;
			if (data.highlighting[id].content && data.highlighting[id].content[0]) {
				doc.content = data.highlighting[id].content[0].replace(/solrFound/g, 'em');
			}
			doc.url = hostUrl + doc.url;
			ret.push(doc);
		});
		return ret;
	}

	function render(template, object) {
		return template.innerHTML.replace(/\\?{([^{}]+)}/g, function (match, name) {
			if (match.charAt(0) === '\\') return match.slice(1);
			return (object[name] != null) ? object[name] : '';
		})
	}

	function renderItems(template, objects) {
		var ret = '';
		objects.forEach(function (object) {
			var tmp = render(template, object);
			tmp = tmp.replace('class="item"', 'class="item root-' + object.root_s + '"');
			ret += tmp;
		});
		return ret;
	}

	// noinspection JSUnusedLocalSymbols
	var __meta_docs_response = {
		highlighting: []
	};
	// noinspection JSUnusedLocalSymbols
	var __meta_doc = {
		id: "",
		content: "",
		root_s: ""
	};

	init();
	return {};
})();

if (!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	};
}
